import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageSquare, Star } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-gold/20 bg-navy-light">
      <div className="max-w-[1720px] mx-auto px-5 sm:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png?v=2" alt="Bridge Taxi, Airport Shuttle & Tours" className="h-16 w-16 rounded-full object-cover ring-1 ring-gold/40" />
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-xl font-bold text-white">Bridge Taxi, Airport Shuttle &amp; Tours</span>
              <span className="text-[11px] uppercase tracking-[0.2em] text-gold mt-1">Est. 2022 · Professional Driving Services</span>
            </span>
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed">
            Premium airport transfers, shuttles and private tours across Halifax, Nova Scotia.
            Reliable drivers, upfront pricing, and a first-class ride every time.
          </p>
          <Link to="/review" data-testid="footer-leave-review" className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/40 px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-gold hover:text-gold">
            <Star className="h-4 w-4 text-gold fill-gold" /> Leave us a review
          </Link>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold mb-4">Explore</h4>
          <ul className="space-y-2.5 text-slate-300">
            <li><Link to="/services" className="hover:text-gold transition-colors duration-200">Services &amp; Pricing</Link></li>
            <li><Link to="/book" className="hover:text-gold transition-colors duration-200">Book a Ride</Link></li>
            <li><Link to="/quote" className="hover:text-gold transition-colors duration-200">Get a Quote</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors duration-200">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors duration-200">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-gold transition-colors duration-200">Admin</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-gold mb-4">Contact</h4>
          <ul className="space-y-3 text-slate-300">
            <li className="flex items-start gap-3"><Phone className="h-4 w-4 text-gold mt-1" /><span className="flex flex-col"><a href="tel:+19024016212" data-testid="footer-phone-1" className="hover:text-gold transition-colors duration-200">902-401-6212</a><a href="tel:+19024407855" data-testid="footer-phone-2" className="hover:text-gold transition-colors duration-200">902-440-7855</a></span></li>
            <li className="flex items-start gap-3"><Mail className="h-4 w-4 text-gold mt-1" /><a href="mailto:info@addistaxiandtour.com" data-testid="footer-email" className="text-gold underline underline-offset-4 decoration-gold/50 hover:decoration-gold transition-colors duration-200 break-all">info@addistaxiandtour.com</a></li>
            <li className="flex items-start gap-3"><MessageSquare className="h-4 w-4 text-gold mt-1" /><a href="https://wa.me/19024407855" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-gold transition-colors duration-200">WhatsApp: 902-440-7855</a></li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 text-gold mt-1" /><span>Halifax, Nova Scotia, Canada</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gold/10 py-6 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} Bridge Taxi, Airport Shuttle &amp; Tours. All rights reserved.
      </div>
    </footer>
  );
}
